import React, { Suspense, useRef, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { TabContext } from "../context";

// import HomePage from "../components/welcome";
// import NotFound from "../utils/NotFound";
// import PricingPage from "../components/welcome/PricingPage";
import LoginPage from "../components/welcome/LoginPage";
// import ContactPage from "../components/welcome/ContactPage";
// import PricingParameters from "../components/welcome/pricing";
// import CustomerOrdering from "../components/welcome/ordering";
// import Attendance from "../components/welcome/attendance";
// import CustomerWithTrnxOrdering from "../components/welcome/ordering/customerwithtrnx";
// import WelcomeOrderQueuing from "../components/welcome/queue/WelcomeOrderQueuing";

const HomePage = React.lazy(() => import("../components/welcome"));
const NotFound = React.lazy(() => import("../utils/NotFound"));
const PricingPage = React.lazy(() =>
  import("../components/welcome/PricingPage")
);
const ContactPage = React.lazy(() =>
  import("../components/welcome/ContactPage")
);
const PricingParameters = React.lazy(() =>
  import("../components/welcome/pricing")
);
const CustomerOrdering = React.lazy(() =>
  import("../components/welcome/ordering")
);
const Attendance = React.lazy(() => import("../components/welcome/attendance"));
const CustomerWithTrnxOrdering = React.lazy(() =>
  import("../components/welcome/ordering/customerwithtrnx")
);
const WelcomeOrderQueuing = React.lazy(() =>
  import("../components/welcome/queue/WelcomeOrderQueuing")
);

const LoginRoute = () => {
  const [selectedTab, setSelectedTab] = useState(
    window.location.pathname === "/"
      ? "home"
      : window.location.pathname === "/contact"
      ? "contact"
      : window.location.pathname.includes("/pricing")
      ? "pricing"
      : ""
  );
  const [openDrawer, setOpenDrawer] = useState(false);
  const facebookButton = useRef();
  const websiteButton = useRef();

  return (
    <React.Fragment>
      <TabContext.Provider
        value={{
          selectedTab,
          setSelectedTab,
          openDrawer,
          setOpenDrawer,
          facebookButton,
          websiteButton,
        }}
      >
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route hidden path="/" element={<HomePage />} />
            <Route hidden path="/login" element={<LoginPage />} />
            <Route hidden path="/contact" element={<ContactPage />} />
            <Route hidden path="/pricing" element={<PricingPage />} />
            <Route
              hidden
              path="/pricing/:plan"
              element={<PricingParameters />}
            />
            <Route
              hidden
              path="/:merchant_id/:merchant_uid"
              element={<CustomerOrdering />}
            />
            <Route
              hidden
              path="/:merchant_id/:merchant_uid/:transaction_id"
              element={<CustomerWithTrnxOrdering />}
            />

            <Route
              hidden
              path="/attendance/:merchant_id/:merchant_uid"
              element={<Attendance />}
            />

            <Route
              hidden
              path="/queuing/:merchant_id/:merchant_uid"
              element={<WelcomeOrderQueuing />}
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </TabContext.Provider>
    </React.Fragment>
  );
};

export default LoginRoute;
